import React, { Component } from 'react';
import { keyBy } from 'lodash';
import { connect } from 'react-redux';

import { StyledDiv } from 'components/Styled';
import FirstMileProvider from 'components/common/firstMileProvider';
import countries from 'data/countries';
import helpers from 'utils/helpers';

class AddressCard extends Component {
  render() {
    const countriesData = keyBy(this.props.countries, 'alpha-2');
    return (
      <div style={{ paddingBottom: this.props.expand ? '14px' : '0' }}>
        <StyledDiv>
          {countriesData[this.props.country].name[this.props.t('key')]}，
          {this.props.address.city || this.props.address.area}
        </StyledDiv>
        {this.props.expand ? (
          <React.Fragment>
            <StyledDiv>
              {this.props.address.street1}
              {this.props.address.street2
                ? '，' + this.props.address.street2
                : null}
              {this.props.address.street3
                ? '，' + this.props.address.street3
                : null}
            </StyledDiv>
            {this.props.address.company ? (
              <StyledDiv>{this.props.address.company}</StyledDiv>
            ) : null}
            <StyledDiv>
              {this.props.address.name}&nbsp; (
              {this.props.address.phoneCc
                ? `+${this.props.address.phoneCc} `
                : ''}
              {this.props.address.phone})
            </StyledDiv>
            {this.props.pickupData &&
              this.props.pickupData.firstMileProvider &&
              this.props.pickupData.firstMileProvider.slug && (
                <StyledDiv>
                  <FirstMileProvider slug={this.props.pickupData.firstMileProvider.slug} />
                </StyledDiv>
              )}
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    countries: state.shipments.countries || countries
  };
};

export default connect(mapStateToProps)(AddressCard);
